// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumbs_breadcrumb__KySjf","breadcrumb__icon":"Breadcrumbs_breadcrumb__icon__UXYyQ","breadcrumbs":"Breadcrumbs_breadcrumbs__blNCd"};